/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { FeedsShowPathParams, FeedsShowResponse } from '../types/FeedsShow'

/**
 * GET /ad-generation/feeds/:feed
 * @see backend/nexus/modules/AdGeneration/Http/Controllers/FeedController.php FeedController::show
 */
export async function feedsShow(
	feed: FeedsShowPathParams['feed'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<FeedsShowResponse>> {
	return axiosInstance.get(`/ad-generation/feeds/${feed}`, config)
}
